import { createBrowserHistory } from 'history'
import * as localforage from 'localforage'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { PersistConfig, persistReducer, persistStore } from 'redux-persist'
import rootReducer from './rootReducer'
import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()

const persistConfig: PersistConfig<any> = {
  key: 'root',
  version: 3,
  storage: localforage,
  blacklist: [],
  whitelist: [],
}

const history = createBrowserHistory()

const dev = process.env.NODE_ENV === 'development'

/**
 * Только если фронтенлд запущен на локальной машине
 */
export const isLocalDev = dev

// Так как сборка для облака прекращает все в html нам надо вычислять NODE_ENV через шаблонизацию в строку
// Но это не получается, так как сборка всегда идет типа в продакшен.
// Поэтому только для разработки мы имеем полное право просто поискать ".dev." в url-е главного API
export const isDevEnv = dev || `${process.env.REACT_APP_GENERAL_API_ENDPOINT}`.includes('.dev.')

let middleware = dev ? applyMiddleware(sagaMiddleware) : applyMiddleware(sagaMiddleware)

if (dev) {
  middleware = composeWithDevTools(middleware)
}

// Хранение данных о пользователе в браузере вызывало ошибки при кейсе:
// когда заканчивались токены и мы меняли тип учетной записи,
// в таком случае мы получали первый рендер с старыми (неверными данными и соответственно совершали неправильные запросы)
// Поэтому отключаем хранение, не выпиливая до конца, чтобы не нагородить больше ошибок
const persistedReducer = persistReducer(persistConfig, rootReducer(history))

export const store = createStore(persistedReducer, middleware)

export default (): any => {
  const persistor = persistStore(store)
  return {
    store,
    persistor,
    runSaga: sagaMiddleware.run(rootSaga),
  }
}

export { history }
